<ng-container *ngIf="supportOptions">
  <vm-yes-no-cta
    *ngIf="!didWorkSelected"
    [content]="getYesNoCtaContent()"
    (pressedYes)="onHasHelpedSelected($event)"></vm-yes-no-cta>

  <div [style.display]="didWorkSelected ? 'block' : 'none'">
    <div class="has-helped-success" *ngIf="didWork">
      <h3>{{ supportOptions.innerHeading }}</h3>
      <vm-animation
        *ngIf="supportOptions.media[0]?.media[0]?.url"
        class="has-helped-success__thumbsup"
        [options]="thumbsUpImageOption"></vm-animation>
      <p class="Body-Light">{{ supportOptions.successMessage }}</p>
      <vm-refer-a-friend
        [optionHeader]="yesButtonImageContent.optionHeader"
        [optionSubHeader]="yesButtonImageContent.optionSubHeader"
        [buttonText]="yesButtonImageContent.buttonText"
        [buttonLink]="yesButtonImageContent.buttonLink"
        [buttonTarget]="yesButtonImageContent.buttonTarget"
        [imageUrl]="yesButtonImageContent.imageLink"
        [attr.data-cy]="'referAFriend'"></vm-refer-a-friend>
    </div>
    <vm-try-something-else
      *ngIf="!didWork"
      (supportOptionSelected)="supportOptionSelected($event)"
      [supportOptions]="supportOptions"
      [liveChatTagId]="liveChatTagId">
    </vm-try-something-else>
  </div>
</ng-container>
